import { render, staticRenderFns } from "./ViewFiles.vue?vue&type=template&id=43ff0c2b&scoped=true"
import script from "./ViewFiles.vue?vue&type=script&lang=js"
export * from "./ViewFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff0c2b",
  null
  
)

export default component.exports